import { IonButton, IonProgressBar, IonText } from '@ionic/react';
import React from 'react';

type UpdateBannerProps = {
  error: string | null;
  updateReady: boolean;
  progress: number;
  installing: boolean;
  onInstall: () => void;
  onRetryCheck: () => void;
};

const UpdateBanner: React.FC<UpdateBannerProps> = ({
  error,
  updateReady,
  progress,
  installing,
  onInstall,
  onRetryCheck,
}) => {
  if (error) {
    return (
      <div className="release-update-banner">
        <IonText className="update-message" color="danger">
          {error}
        </IonText>
        <IonButton
          expand="block"
          onClick={onRetryCheck}
          className="update-action"
        >
          Retry
        </IonButton>
      </div>
    );
  }

  if (updateReady) {
    return (
      <div className="release-update-banner">
        <IonText className="update-message">
          A new version of Crate Hackers is ready!
        </IonText>
        <IonButton
          expand="block"
          onClick={onInstall}
          className="update-action"
          disabled={installing}
        >
          {installing ? 'Installing...' : 'Update Now'}
        </IonButton>
      </div>
    );
  }

  return (
    <div className="release-update-banner">
      <IonText className="update-message">
        Downloading update: {progress}%
      </IonText>
      <IonProgressBar value={progress / 100} className="update-progress-bar" />
    </div>
  );
};

export default UpdateBanner;
